import * as actionType from './ActionType';

export const setStep02 = (data) => ({
  type: actionType.SET_VALUE_STEP02,
  payload: data
});

export const setPayProvider = (payProvider) => ({
  type: actionType.SET_PAY_PROVIDER,
  payload: { payProvider }
});
